<template>
    <div class="timeline-entry">
        
        <div class="timeline-category-tag" :style="{ backgroundColor: color, borderColor: color }" v-motion-slide-visible-left>
            <p class="timeline-category">{{ category }}</p>
        </div>
        
        <div class="timeline-circle" :style="{ borderColor: color }">
            <i :class="['bi', icon]"></i>

        </div>

        <div class="vr" v-motion-slide-visible-bottom></div>

        <div class="timeline-content" v-motion-slide-visible-left>
            <h3 class="timeline-title">{{ title }}</h3>
            <div :id="carouselId" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                    <lightgallery
                        :settings="{ speed: 500, plugins: plugins }"
                        :onInit="onInit"
                        :onBeforeSlide="onBeforeSlide">
                        <a v-for="(image, index) in thumbnail" :key="index" :data-src="getImageUrl(image, index)"
                            :class="['carousel-item', { active: index === 0 }]" :data-bs-interval="index === 0 ? 3000 : 2500"> 
                            <img :src="getImageUrl(image, index)" class="d-block w-100 img-responsive" alt="" />
                        </a>
                    </lightgallery>
                </div>
                <button class="carousel-control-prev" type="button" :data-bs-target="`#${carouselId}`"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" :data-bs-target="`#${carouselId}`"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>


            </div>
            <p class="timeline-description">{{ description }}</p>
        </div>
    
    </div>
</template>
  
<script>
import '@popperjs/core/dist/cjs/popper.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.js';
import Lightgallery from 'lightgallery/vue';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import styles from 'lightgallery/scss/lightgallery.scss';

export default {
    name: "VueTimelineUpdate",
    components: {
        Lightgallery,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        thumbnail: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
        category: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: "code",
        },
    },
    data() {
        return {
            currentImageIndex: 0,
            currentImage: this.thumbnail[0],
            plugins: [lgThumbnail, lgZoom],
            carouselId: `${this.title.replace(/\s+/g, "-").toLowerCase()}-carousel-${this._uid}`
        }
    },
    methods: {
        getImageRef(image) {
            let path = `@/assets/img/projects/${image}`;
            return require(`@/assets/img/projects/${image}`);
        },
        getImageUrl(image, index) {
            return require(`@/assets/img/projects/${image}`);
        },
        onInit: () => {
            console.log('lightGallery has been initialized');
        },
        onBeforeSlide: () => {
            console.log('calling before slide');
        },
    },
};
</script>
  
<style scoped lang="scss">
    @import 'lightgallery/css/lightgallery.css';
    @import 'lightgallery/css/lg-thumbnail.css';
    @import 'lightgallery/css/lg-zoom.css';

@media (max-width: 1235px) {

  .timeline-entry {
    margin-left: 0% !important;
  }

  .timeline-category-tag {
    position: absolute;
    width: 20%;
    margin-left: 4%;
    margin-top: -0.8%; 
  }

  .timeline-circle {
    top: 0;
  }

  .timeline-content {
    margin-left: 0;
    margin-top: 35px;
  }
}

@media (max-width: 600px) {

    .timeline-category-tag {
        position: absolute;
        width: 20%;
        margin-left: -6%;
        margin-top: -0.45%;
}
}

@media (max-width: 1000px) {

.timeline-category-tag {
    position: absolute;
    width: 20%;
    margin-left: -10%;
    margin-top: -0.45%;
}
.timeline-entry {
    padding-right: 6%;
  }
}

@media (max-width: 415px) {

.timeline-category-tag {
    position: absolute;
    width: 20%;
    margin-left: -7%;
    margin-top: -0.45%;
}
}

.timeline-entry {
    display: flex;
    align-items: flex-start;
    margin-bottom: 30px;
    margin-left: 16%;
}

.timeline-category-tag {
    left: 20%;
    position: absolute;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 30px;
    border-radius: 20px;
    border: 3px solid;
    margin-right: 2%;
    margin-top: -0.45%; 
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
}

.timeline-category {
    margin: 0;
    font-size: 14px;
    color: white;
    white-space: pre;
}

.timeline-circle {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border: 3px solid;
    border-radius: 50%;
    top: -5px;
    display: flex;
    align-items: right;
    justify-content: center;
    position: relative;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
}

.timeline-circle::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    height: 100%;
    width: 2px;
    background-color: white;
    z-index: -1;
}

.timeline-circle i {
    font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.timeline-content {
    flex-grow: 1;
    margin-left: 10px;
}

.timeline-title {
    font-size: 18px;
    margin-bottom: 10px;
    text-align: left;
}

.timeline-image {
    margin: 10px 0;
}

.timeline-image img {
    max-width: 100%;
    height: auto;
}

.timeline-description {
    margin-top: 5%;
    font-size: 14px;
    text-align: justify;
}

.carousel-item {
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
}

.carousel-item img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 10px;
}

.carousel-inner {
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
}

.vr {
    position: relative;
    top: 25px;
    left: -15px;
}


</style>